import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useHistory, useParams } from 'react-router-dom';
import axios from '../../core/services/axios';
import { setInitiative } from "../GlobalSelections/InitiativeSelect/actions";

const PetitionShortCode = () => {
  const dispatch = useDispatch();
  const {
    user: { email },
  } = useSelector((state) => state.auth.auth) ?? '';
  const { short_code } = useParams();
  const history = useHistory();

  React.useEffect(() => {
    if (email && short_code) {
      axios
        .get('/api/petitions/meta', {
          params: {
            short_code,
          },
        })
        .then((response) => {
          const { data } = response;
          if (data?.petition_id) {
            dispatch(setInitiative(data.initiative_id));
            history.push(`/petition-field-report?petition_id=${data.petition_id}`);
          } else {
            history.push('/');
          }
        })
        .catch(() => {
          history.push('/');
        });
    }
    // eslint-disable-next-line
  }, [email, short_code]);

  return (
    <div className="pt-3 text-center">
      <div className="sk-spinner sk-spinner-pulse" />
    </div>
  );
};

export default PetitionShortCode;
